import { render, staticRenderFns } from "./ListOtherServices.vue?vue&type=template&id=14701a16&scoped=true&"
import script from "./ListOtherServices.vue?vue&type=script&lang=js&"
export * from "./ListOtherServices.vue?vue&type=script&lang=js&"
import style0 from "./ListOtherServices.vue?vue&type=style&index=0&id=14701a16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14701a16",
  null
  
)

export default component.exports